/* eslint-disable import/no-named-as-default */
import AnchorCenter from '~/pages/AnchorCenter/reducers'
import AnchorTaskSystem from '~/pages/AnchorTaskSystem/reducers'
import ChatCenter from '~/pages/ChatCenter/reducers'
import CoinAgencyRecharge from '~/pages/Coinagency/AgencyRecharge/reducers'
import CoinAgencyWallet from '~/pages/Coinagency/AgencyWallet/reducers'
import DistributorManage from '~/pages/Coinagency/DistributorManage/reducers'
import DoubleRoomTask from '~/pages/DoubleRoomTask/reducer'
// eslint-disable-next-line import/order
import FeedBack from '~/pages/Feedback/reducers'
import GameBackRewards from '~/pages/game/components/BackRewards/reducers'
import GameEggMachine from '~/pages/game/EggMachine/reducers'
import GameGreedyHiya from '~/pages/game/GreedyHiya/reducers'
import GameGreedyPro from '~/pages/game/GreedyProGame/reducers'
import GameLuckySlot from '~/pages/game/LuckySlot/reducers'
import GameRoulette from '~/pages/game/roulette/reducers'
import fruitSlot from '~/pages/game/fruitSlot/reducers'
import GameGuessbox from '~/pages/game/guessbox/reducers'
import GameGreedyBox from '~/pages/game/GreedyBox/reducers'
import GameGuessGift from '~/pages/game/GuessGift/reducers'
import GameHitEgg from '~/pages/game/HitEgg/reducers'
import GameLuckyBigWheel from '~/pages/game/LuckyBigWheel/reducers'
import GameLuckyHiya from '~/pages/game/LuckyHiya/reducers'
import GameTeenPatti from '~/pages/game/TeenPatti/reducers'
import GameWorldCup from '~/pages/game/WorldCup/reducers'
import HorseGame from '~/pages/game/HorseGame/reducers'
import GuildSettled from '~/pages/GuildSettled/reducers'
// import GameTeenPatti from '~/pages/game/TeenPattiNext/reducers'
import Hunting from '~/pages/Hunting/reducers'
import NewBIgR from '~/pages/NewBIgR/reducers'
import NormalVipActive from '~/pages/NormalVipActive/reducers'
import NormalSend from '~/pages/Send/reducers'
import SalaryFeedback from '~/pages/Union/Anchor/SalaryFeedback/reducers'
import WithdrawSalary from '~/pages/Union/Anchor/WithdrawSalary/reducers'
import UnionGatherInfo from '~/pages/Union/GatherInfo/reducers'
import TalentsGatherInfo from '~/pages/TalentsCenter/GatherInfo/reducers'
import UnionData from '~/pages/Union/Leader/Data/reducers'
import unionSettlement from '~/pages/Union/Leader/Settlement/reducers'
import SignUp from '~/pages/Union/Leader/SignUp/reducers'
import UnionLeaderWithdrawSalary from '~/pages/Union/Leader/WithdrawSalary/reducers'
import UnionMedal from '~/pages/Union/Medal/reducers'
import SalaryWallet from '~/pages/Union/SalaryWallet/reducers'
import UnionPK from '~/pages/UnionPK/reducers'
import UnionTask3 from '~/pages/UnionTask3/reducers'
import UserInfoCollection from '~/pages/UserInfoCollection/reducers'
import VChatCenter from '~/pages/VideoChatCenter/reducers'
import Virtual from '~/pages/virtual/reducers'
import Wallet2PayPal from '~/pages/wallet2/PayPal/reducers'
import Wallet2Payoneer from '~/pages/wallet2/payoneer/reducers'
import chatBDHunting from '~/pages/ChatBD/reducers'
import Wallet2Stripe from '~/pages/wallet2/stripe/reducers'
import Wallet2Checkout from '~/pages/wallet2/checkout/reducers'
import Wallet2RechargeExtra from '~/pages/wallet2/rechargeExtra/reducers'
import TalentsCenter from '~/pages/TalentsCenter/reducers'
import LuckyGift from '~/pages/LuckyGift/reducers'
import ChatCp from '~/pages/ChatCp/reducers'
import DistributorManageSuper from '~/pages/Coinagency/DistributorManageSuper/reducers'
import ChatWork from '~/pages/ChatWork/reducers'
import UserTasks from '~/pages/UserTasks/reducers'
import LoveJourney from '~/pages/LoveJourney/reducers'
import WishList from '~/pages/WishList/reducers'
import SelfFission from '~/pages/SelfFission/reducers'
import Airwallex from '~/pages/wallet2/airwallex/reducers'
import OpeningCeremony from '~/pages/Temporary/OpeningCeremony/reducers'
import BlindBoxChallenge from '~/pages/blindBox/challenge/reducers'
import BlindBoxDetail from '~/pages/blindBox/detail/reducers'
import BlindBoxModal from '~/pages/blindBox/GiftModal/reducers'
import Family from '~/pages/family/reducers'
import LoveList from '~/pages/family/love-list/reducers'
import WalletAdvancedQuick from '~/pages/WalletAdvanced/Fast/reducers'
import WalletAdvancedOldUserRecharge from '~/pages/WalletAdvanced/OldUserRecharge/reducers'
import WalletAdvanced from '~/pages/WalletAdvanced/reducers'
import WalletAdvancedExtra from '~/pages/WalletAdvanced/RechargeExtra/reducers'
import FamilyEggMachineSlice from '~/pages/game/FamilyEggMachine/reducers'
import WealthLevel from '~/pages/WealthLevel/reducers'
import Coiner from '~/pages/Coiner/reducers'
import TalentApply from '../pages/TalentApply/reducers'
import CardMixture from '../pages/CardMixture/reducers'
import GiftBook from '../pages/GiftBook/reducers'
import AnchorQuit from './AnchorQuit'
import AnchorQuitList from './AnchorQuitList'
import CrossRoomPkRank from './CrossRoomPkRank'
import GeneralLottery from './GeneralLottery'
import UnionTask from './UnionTask'
import wallet from './wallet'
import Medal from './medal'

export default {
  ...Medal,
  Wallet2PayPal,
  Wallet2Stripe,
  SalaryFeedback,
  Virtual,
  unionSettlement,
  UnionPK,
  NewBIgR,
  GameGuessbox,
  GameGreedyBox,
  UnionTask,
  GeneralLottery,
  CrossRoomPkRank,
  AnchorQuit,
  AnchorQuitList,
  DoubleRoomTask,
  GameGreedyHiya,
  GameGreedyPro,
  GameLuckySlot,
  GameRoulette,
  fruitSlot,
  Hunting,
  wallet,
  WithdrawSalary,
  UnionData,
  SignUp,
  NormalSend,
  GameLuckyHiya,
  UserInfoCollection,
  GameBackRewards,
  GameEggMachine,
  CoinAgencyWallet,
  CoinAgencyRecharge,
  UnionLeaderWithdrawSalary,
  UnionTask3,
  UnionMedal,
  AnchorTaskSystem,
  NormalVipActive,
  GameLuckyBigWheel,
  ChatCenter,
  GameGuessGift,
  FeedBack,
  UnionGatherInfo,
  DistributorManage,
  GameTeenPatti,
  GameHitEgg,
  GameWorldCup,
  HorseGame,
  AnchorCenter,
  VChatCenter,
  GuildSettled,
  GiftBook,
  LuckyGift,
  SalaryWallet,
  CardMixture,
  Wallet2Checkout,
  TalentApply,
  TalentsCenter,
  DistributorManageSuper,
  Wallet2Payoneer,
  TalentsGatherInfo,
  chatBDHunting,
  ChatCp,
  ChatWork,
  UserTasks,
  Wallet2RechargeExtra,
  LoveJourney,
  SelfFission,
  WishList,
  OpeningCeremony,
  BlindBoxChallenge,
  BlindBoxDetail,
  BlindBoxModal,
  Family,
  LoveList,
  Airwallex,
  WalletAdvanced,
  WalletAdvancedQuick,
  WalletAdvancedOldUserRecharge,
  WalletAdvancedExtra,
  FamilyEggMachineSlice,
  WealthLevel,
  Coiner,
}
